"use strict";
import { useCallback, useContext } from "react";
import { ShellContext } from "../context";
import { resolvePath, useLocation } from "react-router";
export function useShellModulePathResolver() {
  let { moduleRootPath } = useContext(ShellContext);
  const location = useLocation();
  return useCallback(
    ((module, path) => {
      if (path === void 0) return void 0;
      const { id } = module;
      let finalPath = path;
      if (!path.startsWith("/")) finalPath = `/${finalPath}`;
      if (finalPath === "/") finalPath = "";
      if (moduleRootPath === "/") moduleRootPath = "";
      return resolvePath(`${moduleRootPath}/${id}${finalPath}`, location.pathname).pathname;
    }),
    [moduleRootPath]
  );
}
